import React from 'react';
import GIETextField from '../../components/GIETextField/GieTextField';
import GIEButton from '../../components/GIEButton/GieButton';
import {FormValidator} from '../../util/form-validator';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {MenuItem} from "@material-ui/core";
import {Select} from "@mui/material";

const dataEmergency = [
  {label: 'Panne de chauffage et/ou eau chaude', value: 'liming_failure'},
  {label: 'Fuite sur l’installation', value: 'leakage'},
  //{label:'Autre intervention',value:'other'}
]

export default class EmergencyDescription extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();

  constructor(props: any) {
    super(props);
    this.state = {
      isValid: true,
      formControls: {
        description: {
          value: '',
          error: false,
          errorMessage: ''
        },
        nature: {
          value: 'liming_failure',
          error: false,
          errorMessage: ''

        }
      }
    }
    this.checkValidForm = this.checkValidForm.bind(this);
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;
    });
    this.setState(formControls)
  }

  handleSubmit = () => {
    this.checkValidForm();
    if (this.state.formControls.description.error === false) {
      this.props.next(this.state.formControls);
    }
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value,
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    });
  }

  changeChoice = (event) => {
    let formControls = this.state.formControls;
    formControls.nature.value = event.target.value;
    this.setState({formControls})
  }

  render() {
    return (
      <div>
        <FormControl variant='outlined' fullWidth margin="normal" className="mt-4">
          <InputLabel id="panne-lbl" shrink disableAnimation className="gie-label" required>
            Nature de votre panne
          </InputLabel>
          <Select labelId="panne-lbl" value={this.state.formControls.nature.value} fullWidth variant="outlined"
                  onChange={this.changeChoice}>
            {
              dataEmergency.map((item) => <MenuItem value={item.value} key={item.value}>
                {item.label}
              </MenuItem>)
            }
          </Select>
        </FormControl>

        <GIETextField label="Description de votre panne"
                      required
                      onChange={this.changeHandler}
                      name="description"
                      value={this.state.formControls.description.value}
                      error={this.state.formControls.description.error}
                      helperText={this.state.formControls.description.errorMessage}
                      multiline
                      rows={5}
                      placeholder="Description de votre panne"/>
        <div className="text-center my-4">
          <GIEButton onClick={this.handleSubmit} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
        </div>
      </div>
    );
  }
}
